import React, { useState, useMemo, useEffect } from 'react';
import { Plus, Minus, X } from 'lucide-react';
import { db, auth } from '../firebase';
import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  onSnapshot,
  query,
  where,
  Timestamp,
  setDoc,
  getDoc,
  getDocs,
  orderBy,
  deleteField
} from 'firebase/firestore';

export default function CabinetCalculator({ 
  onClose, 
  currentProject, 
  swornData, 
  setSwornData,
  savedCabinetQuantities = {},
  savedCabinetPricingType,
  addToast
}) {
  const [cabinetQuantities, setCabinetQuantities] = useState(savedCabinetQuantities);
  const [features, setFeatures] = useState({});
  const [laborCabs, setLaborCabs] = useState(0);
  const [laborExtra, setLaborExtra] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [cabinetLaborUnits, setCabinetLaborUnits] = useState(0);

  const cabinetData = {
    base: [
      { code: 'SB24DD', actual: 990, rvcg: 585, sqft: 4.2, pulls: 2, pullSize: '7"' },
      { code: 'SB27', actual: 1000, rvcg: 595, sqft: 4.7, pulls: 2, pullSize: '7"' },
      { code: 'SB30', actual: 1033, rvcg: 628, sqft: 5.21, pulls: 2, pullSize: '7"' },
      { code: 'SB33', actual: 1061, rvcg: 656, sqft: 5.73, pulls: 2, pullSize: '7"' },
      { code: 'SB36', actual: 1079, rvcg: 674, sqft: 6.25, pulls: 2, pullSize: '7"' },
      { code: 'SB39', actual: 1262, rvcg: 695, sqft: 6.77, pulls: 2, pullSize: '7"' },
      { code: 'SB42', actual: 1355, rvcg: 788, sqft: 7.3, pulls: 2, pullSize: '7"' },
      { code: 'FSB36', actual: 1418, rvcg: 1013, sqft: 6.25, pulls: 2, pullSize: '7"' },
      { code: 'SS36', actual: 1906, rvcg: 1501, sqft: 8.16, pulls: 1, pullSize: '7"' },
      { code: 'LS36', actual: 1505, rvcg: 1100, sqft: 8.16, pulls: 1, pullSize: '7"' },
      { code: 'BER33', actual: 1240, rvcg: 835, sqft: 7.12, pulls: 1, pullSize: '7"' },
      { code: 'BER36', actual: 1255, rvcg: 850, sqft: 8.16, pulls: 1, pullSize: '7"' },
      { code: 'BMW30', actual: 1435, rvcg: 1030, sqft: 5.21, pulls: 1, pullSize: '10"' },
      { code: 'BWB18', actual: 1583, rvcg: 1239, sqft: 3.18, pulls: 2, pullSize: '7"' },
      { code: 'B36', actual: 1468, rvcg: 1063, sqft: 6.25, pulls: 3, pullSize: '10"' },
      { code: 'B33', actual: 1322, rvcg: 917, sqft: 5.73, pulls: 3, pullSize: '10"' },
      { code: 'B30', actual: 1276, rvcg: 871, sqft: 5.21, pulls: 3, pullSize: '7"' },
      { code: 'B27', actual: 1227, rvcg: 822, sqft: 4.7, pulls: 3, pullSize: '7"' },
      { code: 'B24DD', actual: 1214, rvcg: 809, sqft: 4.2, pulls: 3, pullSize: '7"' },
      { code: 'B21', actual: 1030, rvcg: 686, sqft: 3.72, pulls: 2, pullSize: '7"' },
      { code: 'B18', actual: 1000, rvcg: 656, sqft: 3.18, pulls: 2, pullSize: '7"' },
      { code: 'B15', actual: 955, rvcg: 611, sqft: 2.66, pulls: 2, pullSize: '7"' },
      { code: 'B12', actual: 899, rvcg: 555, sqft: 2.13, pulls: 2, pullSize: '7"' },
      { code: 'B09', actual: 863, rvcg: 519, sqft: 1.6, pulls: 2, pullSize: '7"' },
      { code: 'B36D3', actual: 1820, rvcg: 1415, sqft: 6.375, pulls: 3, pullSize: '10"' },
      { code: 'B30D3', actual: 1743, rvcg: 1338, sqft: 5.21, pulls: 3, pullSize: '7"' },
      { code: 'B27D3', actual: 0, rvcg: 1416, sqft: 4.7, pulls: 3, pullSize: '7"' },
      { code: 'B24D3', actual: 1214, rvcg: 1146, sqft: 4.2, pulls: 3, pullSize: '7"' },
      { code: 'B21D3', actual: 1427, rvcg: 1083, sqft: 3.72, pulls: 3, pullSize: '7"' },
      { code: 'B18D3', actual: 1363, rvcg: 1019, sqft: 3.18, pulls: 3, pullSize: '7"' },
      { code: 'B15D3', actual: 1296, rvcg: 952, sqft: 2.66, pulls: 3, pullSize: '7"' },
      { code: 'B12D3', actual: 1230, rvcg: 886, sqft: 2.13, pulls: 3, pullSize: '7"' },
      { code: 'U249624', actual: 2321, rvcg: 1754, sqft: 0, pulls: 2, pullSize: '10"' },
      { code: 'OCD339624', actual: 3489, rvcg: 2555, sqft: 0, pulls: 2, pullSize: '10"' },
    ],
    wall: [
      { code: 'W0942', actual: 669, rvcg: 325, sqft: 0, pulls: 1, pullSize: '7"' },
      { code: 'W1242', actual: 733, rvcg: 389, sqft: 0, pulls: 1, pullSize: '7"' },
      { code: 'W1542', actual: 770, rvcg: 426, sqft: 0, pulls: 1, pullSize: '7"' },
      { code: 'W1842', actual: 817, rvcg: 473, sqft: 0, pulls: 1, pullSize: '7"' },
      { code: 'W2142', actual: 852, rvcg: 508, sqft: 0, pulls: 1, pullSize: '7"' },
      { code: 'W2442DD', actual: 816, rvcg: 612, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'W2742', actual: 1033, rvcg: 628, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'W3042', actual: 1079, rvcg: 674, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'W3342', actual: 1116, rvcg: 711, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'W3642', actual: 1173, rvcg: 768, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'W4242', actual: 1369, rvcg: 886, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'RW3318', actual: 817, rvcg: 473, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'RW3324', actual: 995, rvcg: 651, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'RW3612', actual: 828, rvcg: 484, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'RW3618', actual: 835, rvcg: 473, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'RW3624', actual: 995, rvcg: 651, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'WER2442', actual: 1294, rvcg: 0, sqft: 0, pulls: 1, pullSize: '7"' },
      { code: 'W3018', actual: 694, rvcg: 318, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'W3024', actual: 908, rvcg: 564, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'W3615', actual: 694, rvcg: 350, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'W3618', actual: 733, rvcg: 389, sqft: 0, pulls: 2, pullSize: '7"' },
      { code: 'W3624', actual: 1004, rvcg: 660, sqft: 0, pulls: 2, pullSize: '7"' },
    ],
    vanity: [
      { code: 'VSB24DD', actual: 925, rvcg: 520, sqft: 3.75, pulls: 2, pullSize: '7"' },
      { code: 'VSB27', actual: 941, rvcg: 536, sqft: 4.23, pulls: 2, pullSize: '7"' },
      { code: 'VSB30', actual: 980, rvcg: 575, sqft: 4.7, pulls: 2, pullSize: '7"' },
      { code: 'VSB33', actual: 1000, rvcg: 595, sqft: 5.16, pulls: 2, pullSize: '7"' },
      { code: 'VSB36', actual: 1024, rvcg: 619, sqft: 5.63, pulls: 2, pullSize: '7"' },
      { code: 'VSB48', actual: 1308, rvcg: 741, sqft: 7.5, pulls: 4, pullSize: '7"' },
      { code: 'VSB60DB4', actual: 3137, rvcg: 2107, sqft: 9.375, pulls: 7, pullSize: '7"' },
      { code: 'VSDB36', actual: 1711, rvcg: 919, sqft: 5.63, pulls: 5, pullSize: '7"', hasSink: true },
      { code: 'VSDB42', actual: 1872, rvcg: 1080, sqft: 6.56, pulls: 5, pullSize: '7"', hasSink: true },
      { code: 'VSDB48', actual: 1934, rvcg: 1142, sqft: 7.5, pulls: 5, pullSize: '7"', hasSink: true },
      { code: 'VBL30', actual: 1804, rvcg: 1399, sqft: 4.69, pulls: 5, pullSize: '7"' },
      { code: 'VBR30', actual: 1804, rvcg: 1399, sqft: 4.69, pulls: 5, pullSize: '7"' },
      { code: 'VBL36', actual: 2230, rvcg: 1438, sqft: 5.63, pulls: 5, pullSize: '7"' },
      { code: 'VBR36', actual: 2230, rvcg: 1438, sqft: 5.63, pulls: 5, pullSize: '7"' },
      { code: 'VBL42', actual: 2284, rvcg: 1492, sqft: 6.56, pulls: 5, pullSize: '7"' },
      { code: 'VBR42', actual: 2284, rvcg: 1492, sqft: 6.56, pulls: 5, pullSize: '7"' },
      { code: 'VB12', actual: 875, rvcg: 531, sqft: 1.875, pulls: 2, pullSize: '7"' },
      { code: 'VB15', actual: 880, rvcg: 536, sqft: 2.343, pulls: 2, pullSize: '7"' },
      { code: 'VB18', actual: 927, rvcg: 583, sqft: 2.82, pulls: 2, pullSize: '7"' },
      { code: 'VDB12', actual: 1077, rvcg: 733, sqft: 1.875, pulls: 3, pullSize: '7"' },
      { code: 'VDB15', actual: 1141, rvcg: 797, sqft: 2.343, pulls: 3, pullSize: '7"' },
      { code: 'VDB18', actual: 1179, rvcg: 835, sqft: 2.82, pulls: 3, pullSize: '7"' },
    ],
    accessories: [
      { code: 'ROINSTKIT', actual: 142, rvcg: 142, sqft: 0 },
      { code: 'POSSC24', actual: 228, rvcg: 228, sqft: 0 },
      { code: 'FRIDGE PANEL', actual: 1763, rvcg: 880, sqft: 0 },
      { code: '3X42', actual: 134, rvcg: 63, sqft: 0 },
      { code: '3X96', actual: 203, rvcg: 115, sqft: 0 },
      { code: '6X42', actual: 197, rvcg: 126, sqft: 0 },
      { code: '6X96', actual: 318, rvcg: 230, sqft: 0 },
      { code: 'BACK PANEL', actual: 859, rvcg: 332, sqft: 0 },
      { code: 'DWP1.5', actual: 434, rvcg: 162, sqft: 0 },
      { code: 'DWP3', actual: 439, rvcg: 167, sqft: 0 },
      { code: 'DWP6', actual: 558, rvcg: 286, sqft: 0 },
      { code: 'OC', actual: 149, rvcg: 78, sqft: 0 },
      { code: 'SCRIBE', actual: 125, rvcg: 53, sqft: 0 },
      { code: 'LARGE CROWN', actual: 276, rvcg: 154, sqft: 0 },
      { code: 'TOEKICK', actual: 126, rvcg: 53, sqft: 0 },
      { code: 'LINEN CAB W/ DRAWERS', actual: 2329, rvcg: 1762, sqft: 0, pulls: 3, pullSize: '7"' },
      { code: 'LINEN CAB', actual: 2329, rvcg: 1104, sqft: 0, pulls: 2, pullSize: '7"' },
    ]
  };

  const featurePrices = {
    'Locking Door Handle Interior': 45,
    'Hall/Closet Door Handle Interior': 40,
    'Pocket Door Handle': 55,
    'Exterior Lock Sets': 145,
    'Dummy Knobs': 30,
    '5" Cabinet Door Pulls': 15,
    '7" Cabinet Door Pulls': 20,
    '10" Cabinet Door Pulls': 30,
    'Mirrors / Brackets': 150,
    '4-8\' Bench': 1000,
    '8\' or more Bench': 1000,
    'Countertop Entry Level': 70.11,
    'Countertop Group A': 75.58,
    'Countertop Group B': 81.05,
    'Countertop OTHER': 93.50,
    'Kitchen Sink UM': 612,
    'Kitchen Sink Upgrade': 850,
    'Kitchen Sink Upgrade (Kraus)': 1270,
    'Vanity Sink Rectangle': 350,
    'Vanity Sink Oval': 320,
    'Laundry': 445,
    'Bar': 445,
  };

  const getItemKey = (category, item) => `${category}|||${item}`;

  const getItemData = (category, item) => {
    const key = getItemKey(category, item);
    return swornData?.items?.[key] || {
      originalBidCost: 0,
      contractorName: '',
      jobComplete: false,
      draws: [0, 0, 0, 0, 0, 0, 0, 0],
      changeOrders: 0
    };
  };

  const applyPricingToCabinets = async (calculations, features, laborCabs, laborExtra) => {
    setIsSaving(true);
    if (addToast) {
      addToast('Saving cabinet pricing...', 'info', 10000);
    }
    
    try {
      const updates = {};
      
      // 7" PULLS - ADD manual override to calculated (instead of replacing)
      const manualPulls7 = features['7" Cabinet Door Pulls'] || 0;
      const finalPulls7 = calculations.pulls7 + manualPulls7;
      const pulls7Cost = finalPulls7 * featurePrices['7" Cabinet Door Pulls'];
      const key7 = getItemKey('Cabinetry', '7" Cabinet Door Pulls');
      const currentData7 = getItemData('Cabinetry', '7" Cabinet Door Pulls');
      updates[key7] = { ...currentData7, originalBidCost: pulls7Cost };
      
      // 10" PULLS - ADD manual override to calculated (instead of replacing)
      const manualPulls10 = features['10" Cabinet Door Pulls'] || 0;
      const finalPulls10 = calculations.pulls10 + manualPulls10;
      const pulls10Cost = finalPulls10 * featurePrices['10" Cabinet Door Pulls'];
      const key10 = getItemKey('Cabinetry', '10" Cabinet Door Pulls');
      const currentData10 = getItemData('Cabinetry', '10" Cabinet Door Pulls');
      updates[key10] = { ...currentData10, originalBidCost: pulls10Cost };
      
      // 5" PULLS - Only if manually entered (no auto-calculation)
      if (features['5" Cabinet Door Pulls'] && features['5" Cabinet Door Pulls'] > 0) {
        const pulls5Cost = features['5" Cabinet Door Pulls'] * featurePrices['5" Cabinet Door Pulls'];
        const key5 = getItemKey('Cabinetry', '5" Cabinet Door Pulls');
        const currentData5 = getItemData('Cabinetry', '5" Cabinet Door Pulls');
        updates[key5] = { ...currentData5, originalBidCost: pulls5Cost };
      }
      
      // COUNTERTOPS - ADD manual override to calculated
      const countertopTypes = [
        { name: 'Entry Level', price: featurePrices['Countertop Entry Level'] },
        { name: 'Group A', price: featurePrices['Countertop Group A'] },
        { name: 'Group B', price: featurePrices['Countertop Group B'] },
        { name: 'OTHER', price: featurePrices['Countertop OTHER'] }
      ];
      
      countertopTypes.forEach(({ name, price }) => {
        const featureName = `Countertop ${name}`;
        // ADD manual sqft to calculated sqft (instead of replacing)
        const manualSqft = features[featureName] || 0;
        const totalSqft = calculations.sqftTotal + manualSqft;
        const countertopCost = parseFloat((totalSqft * price).toFixed(2));
        
        const keyCountertop = getItemKey('Cabinetry', featureName);
        const currentDataCountertop = getItemData('Cabinetry', featureName);
        updates[keyCountertop] = { ...currentDataCountertop, originalBidCost: countertopCost };
      });
      
      // CABINET TOTALS
      const keyWhite = getItemKey('Cabinetry', 'Kitchen/Vanities Cabinets White');
      const currentDataWhite = getItemData('Cabinetry', 'Kitchen/Vanities Cabinets White');
      updates[keyWhite] = { ...currentDataWhite, originalBidCost: calculations.whiteCabinetTotal };

      const keyColored = getItemKey('Cabinetry', 'Kitchen/Vanities Cabinets Colored');
      const currentDataColored = getItemData('Cabinetry', 'Kitchen/Vanities Cabinets Colored');
      updates[keyColored] = { ...currentDataColored, originalBidCost: calculations.colorCabinetTotal };
      
      // LABOR
      const keyLabor = getItemKey('Cabinetry', 'Labor');
      const currentDataLabor = getItemData('Cabinetry', 'Labor');
      updates[keyLabor] = { ...currentDataLabor, originalBidCost: calculations.laborTotal };
      
      // VANITY SINKS - ADD manual override to calculated
      const manualVanitySinksRect = features['Vanity Sink Rectangle'] || 0;
      const finalVanitySinksRect = calculations.vanitySinks + manualVanitySinksRect;
      if (finalVanitySinksRect > 0) {
        const vanitySinkCost = finalVanitySinksRect * featurePrices['Vanity Sink Rectangle'];
        const keyVanitySink = getItemKey('Cabinetry', 'Vanity Sink Rectangle');
        const currentDataVanitySink = getItemData('Cabinetry', 'Vanity Sink Rectangle');
        updates[keyVanitySink] = { ...currentDataVanitySink, originalBidCost: vanitySinkCost };
      }
      
      // ALL OTHER FEATURES - Only save if quantity > 0
      const excludeFromLoop = [
        '5" Cabinet Door Pulls',
        '7" Cabinet Door Pulls', 
        '10" Cabinet Door Pulls',
        'Countertop Entry Level',
        'Countertop Group A',
        'Countertop Group B',
        'Countertop OTHER',
        'Vanity Sink Rectangle'
      ];
      
      Object.entries(features).forEach(([featureName, quantity]) => {
        // Skip if already handled or if quantity is 0
        if (excludeFromLoop.includes(featureName) || !quantity || quantity <= 0) {
          return;
        }
        
        const unitPrice = featurePrices[featureName] || 0;
        const cost = quantity * unitPrice;
        
        // Determine category
        const category = (
          featureName.includes('Kitchen Sink') || 
          featureName.includes('Vanity Sink') || 
          featureName.includes('Laundry') || 
          featureName.includes('Bar') ||
          featureName.includes('Bench')
        ) ? 'Cabinetry' : 'Millwork';
        
        const key = getItemKey(category, featureName);
        const currentData = getItemData(category, featureName);
        updates[key] = { ...currentData, originalBidCost: cost };
      });
      
      // UPDATE FIRESTORE AND LOCAL STATE
      const updatedSwornData = {
        ...swornData,
        items: {
          ...swornData.items,
          ...updates
        },
        cabinetQuantities: cabinetQuantities,
        cabinetFeatures: features,
        cabinetLaborCabs: laborCabs,
        cabinetLaborExtra: laborExtra,
        cabinetLaborUnits: cabinetLaborUnits
      };
      
      setSwornData(updatedSwornData);

      const docRef = doc(db, 'swornStatements', currentProject.id);
      await setDoc(docRef, {
        items: updatedSwornData.items,
        cabinetQuantities: cabinetQuantities,
        cabinetFeatures: features,
        cabinetLaborCabs: laborCabs,
        cabinetLaborExtra: laborExtra,
        cabinetLaborUnits: cabinetLaborUnits,
        updatedAt: Timestamp.now()
      }, { merge: true });
      
      if (addToast) {
        addToast('Cabinet pricing saved successfully!', 'success');
      }
      onClose();
    } catch (error) {
      console.error('Error applying cabinet pricing:', error);
      if (addToast) {
        addToast('Error saving cabinet pricing. Please try again.', 'error');
      } else {
        alert('Error saving cabinet pricing. Please try again.');
      }
    } finally {
      setIsSaving(false);
    }
  };

  const calculations = useMemo(() => {
    let whiteCabinetTotal = 0, colorCabinetTotal = 0, sqftTotal = 0, pulls7 = 0, pulls10 = 0, vanitySinks = 0;
    
    [...cabinetData.base, ...cabinetData.wall, ...cabinetData.vanity].forEach(cab => {
      const qty = cabinetQuantities[cab.code] || 0;
      if (qty > 0) {
        const whiteCost = cab.rvcg * 0.46 * 1.35;
        whiteCabinetTotal += whiteCost * qty;

        const actualWithTax = cab.actual * 1.07;
        const colorCost = actualWithTax * 0.385 * 1.35;
        colorCabinetTotal += colorCost * qty;
        
        if (cab.sqft) sqftTotal += cab.sqft * qty;
        if (cab.pulls) {
          if (cab.pullSize === '7"') pulls7 += cab.pulls * qty;
          else if (cab.pullSize === '10"') pulls10 += cab.pulls * qty;
        }
        if (cab.hasSink) vanitySinks += qty;
      }
    });
    
    cabinetData.accessories.forEach(acc => {
      const qty = cabinetQuantities[acc.code] || 0;
      if (qty > 0) {
        const whiteCost = acc.rvcg * 0.46 * 1.35;
        whiteCabinetTotal += whiteCost * qty;

        const actualWithTax = acc.actual * 1.07;
        const colorCost = actualWithTax * 0.385 * 1.35;
        colorCabinetTotal += colorCost * qty;
        
        if (acc.pulls) {
          if (acc.pullSize === '7"') pulls7 += acc.pulls * qty;
          else if (acc.pullSize === '10"') pulls10 += acc.pulls * qty;
        }
      }
    });

    const vanitySinkGroup1 = ['VSB24DD', 'VSB27', 'VSB30', 'VSB33', 'VSB36', 'VSB48']
      .reduce((sum, code) => sum + (cabinetQuantities[code] || 0), 0);

    const vanitySinkGroup2 = (cabinetQuantities['VSB60DB4'] || 0) * 2;
    
    const vanitySinkGroup3 = ['VSDB36', 'VSDB42', 'VSDB48', 'VBL30', 'VBR30', 'VBL36', 'VBR36', 'VBL42', 'VBR42']
      .reduce((sum, code) => sum + (cabinetQuantities[code] || 0), 0);
    
    const totalVanitySinks = vanitySinkGroup1 + vanitySinkGroup2 + vanitySinkGroup3;
    
    // CHANGED: Add manual entries to calculated values instead of replacing
    const manualPulls7 = features['7" Cabinet Door Pulls'] || 0;
    const manualPulls10 = features['10" Cabinet Door Pulls'] || 0;
    const finalPulls7 = pulls7 + manualPulls7;
    const finalPulls10 = pulls10 + manualPulls10;
    
    const pulls7Cost = finalPulls7 * featurePrices['7" Cabinet Door Pulls'];
    const pulls10Cost = finalPulls10 * featurePrices['10" Cabinet Door Pulls'];
    
    // CHANGED: Add manual sqft to calculated sqft for each countertop type
    const manualSqftEntryLevel = features['Countertop Entry Level'] || 0;
    const manualSqftGroupA = features['Countertop Group A'] || 0;
    const manualSqftGroupB = features['Countertop Group B'] || 0;
    const manualSqftOther = features['Countertop OTHER'] || 0;
    
    const countertopEntryLevel = (sqftTotal + manualSqftEntryLevel) * featurePrices['Countertop Entry Level'];
    const countertopGroupA = (sqftTotal + manualSqftGroupA) * featurePrices['Countertop Group A'];
    const countertopGroupB = (sqftTotal + manualSqftGroupB) * featurePrices['Countertop Group B'];
    const countertopOther = (sqftTotal + manualSqftOther) * featurePrices['Countertop OTHER'];
    
    // CHANGED: Add manual vanity sinks to calculated
    const manualVanitySinks = features['Vanity Sink Rectangle'] || 0;
    const finalVanitySinks = totalVanitySinks + manualVanitySinks;
    const vanitySinkCost = finalVanitySinks * featurePrices['Vanity Sink Rectangle'];
    
    let featuresTotal = 0;
    Object.keys(features).forEach(f => { 
      const qty = features[f] || 0;
      if (qty > 0 && !f.includes('Countertop') && f !== '7" Cabinet Door Pulls' && f !== '10" Cabinet Door Pulls' && f !== 'Vanity Sink Rectangle') {
        featuresTotal += qty * (featurePrices[f] || 0);
      }
    });
    
    const laborTotal = laborCabs * 50 + laborExtra * 75 + cabinetLaborUnits * 50;
    
    return { 
      whiteCabinetTotal, 
      colorCabinetTotal, 
      sqftTotal, 
      pulls7,  // Auto-calculated value
      pulls10, // Auto-calculated value
      vanitySinks: totalVanitySinks, // Auto-calculated value
      manualPulls7,  // Manual override
      manualPulls10, // Manual override
      manualVanitySinks, // Manual override
      finalPulls7,   // Combined total
      finalPulls10,  // Combined total
      finalVanitySinks, // Combined total
      pulls7Cost,
      pulls10Cost,
      countertopEntryLevel,
      countertopGroupA,
      countertopGroupB,
      countertopOther,
      vanitySinkCost,
      featuresTotal, 
      laborTotal, 
      grandTotalWhite: whiteCabinetTotal + featuresTotal + laborTotal,
      grandTotalColor: colorCabinetTotal + featuresTotal + laborTotal
    };
  }, [cabinetQuantities, features, laborCabs, laborExtra, cabinetLaborUnits]);

  useEffect(() => {
    if (swornData?.cabinetFeatures) {
      setFeatures(swornData.cabinetFeatures);
    }
    if (swornData?.cabinetLaborCabs !== undefined) {
      setLaborCabs(swornData.cabinetLaborCabs);
    }
    if (swornData?.cabinetLaborExtra !== undefined) {
      setLaborExtra(swornData.cabinetLaborExtra);
    }
    if (swornData?.cabinetLaborUnits !== undefined) {
      setCabinetLaborUnits(swornData.cabinetLaborUnits);
    }
  }, [swornData]);

  const CabinetSection = ({ title, items }) => {
    const filtered = items.filter(i => !searchTerm || i.code.toLowerCase().includes(searchTerm.toLowerCase()));
    if (!filtered.length) return null;
    return (
      <div style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>{title}</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1rem' }}>
          {filtered.map(item => {
            const qty = cabinetQuantities[item.code] || 0;
            return (
              <div key={item.code} style={{ border: qty > 0 ? '2px solid #3B82F6' : '1px solid #E5E7EB', borderRadius: '8px', padding: '1rem',
                backgroundColor: 'white', boxShadow: qty > 0 ? '0 4px 6px rgba(59,130,246,0.1)' : '0 1px 3px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.75rem' }}>
                  <div>
                    <div style={{ fontWeight: '600', color: '#1F2937', fontSize: '15px' }}>{item.code}</div>
                    {item.sqft && <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '2px' }}>{item.sqft} sqft</div>}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <button onClick={() => setCabinetQuantities(p => ({ ...p, [item.code]: Math.max(0, (p[item.code] || 0) - 1) }))} disabled={qty === 0}
                      style={{ width: '32px', height: '32px', borderRadius: '6px', backgroundColor: qty === 0 ? '#E5E7EB' : '#EF4444',
                        color: qty === 0 ? 'black' : 'white', border: 'none', cursor: qty === 0 ? 'not-allowed' : 'pointer',
                        display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      -
                    </button>
                    <span style={{ width: '32px', textAlign: 'center', fontWeight: '600', fontSize: '15px' }}>{qty}</span>
                    <button onClick={() => setCabinetQuantities(p => ({ ...p, [item.code]: (p[item.code] || 0) + 1 }))}
                      style={{ width: '32px', height: '32px', borderRadius: '6px', backgroundColor: '#10B981', color: 'white', border: 'none',
                        cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      +
                    </button>
                  </div>
                </div>
                {qty > 0 && (
                  <div style={{ fontSize: '14px', paddingTop: '0.75rem', borderTop: '1px solid #E5E7EB' }}>
                    <div style={{ color: '#2563EB', fontWeight: '600', marginBottom: '4px' }}>
                      White: ${((item.rvcg * 1.07 * 0.46 * 1.35) * qty).toFixed(2)}
                    </div>
                    <div style={{ color: '#D97706', fontWeight: '600' }}>
                      Colored: ${((item.actual * 1.07 * 0.385 * 1.35) * qty).toFixed(2)}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div style={{ backgroundColor: 'white', borderRadius: '12px', width: '100%', maxWidth: '1400px', 
      maxHeight: '90vh', overflow: 'auto', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)', position: 'relative' }}>
      
      <div style={{ position: 'sticky', top: 0, backgroundColor: 'white', borderBottom: '1px solid #E5E7EB', 
        padding: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 10 }}>
        <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#1F2937', margin: 0 }}>Cabinet & Features Pricing Calculator</h1>
        {onClose && (
          <button onClick={() => applyPricingToCabinets(calculations, features, laborCabs, laborExtra)} 
            style={{ padding: '8px', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', 
              borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <X size={24} color="#6B7280" />
          </button>
        )}
      </div>

      <div style={{ padding: '1.5rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', 
          marginBottom: '1.5rem', padding: '1rem', backgroundColor: '#F9FAFB', borderRadius: '8px' }}>
          <div>
            <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6B7280', marginBottom: '0.5rem' }}>Search Cabinets</label>
            <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search by model..." 
              style={{ width: '95%', padding: '8px 12px', border: '1px solid #D1D5DB', borderRadius: '6px', fontSize: '14px' }} />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6B7280', marginBottom: '0.5rem' }}>Actions</label>
            <button onClick={() => { setCabinetQuantities({}); setFeatures({}); setLaborCabs(0); setLaborExtra(0); setCabinetLaborUnits(0); }} 
              style={{ padding: '8px 16px', backgroundColor: '#EF4444', color: 'white', border: 'none', borderRadius: '6px', 
                cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>
              Clear All
            </button>
            <button 
              onClick={() => { applyPricingToCabinets(calculations, features, laborCabs, laborExtra); }} 
              disabled={isSaving}
              style={{ padding: '8px 16px', backgroundColor: isSaving ? '#9CA3AF' : 'green', color: 'white', border: 'none', borderRadius: '6px', 
                cursor: isSaving ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '600', marginLeft: '8px' }}>
              {isSaving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
          {/* 7" Pulls Card */}
          <div style={{ backgroundColor: '#E3F2FD', padding: '1.25rem', borderRadius: '8px', border: '2px solid #2196F3' }}>
            <div style={{ fontSize: '11px', color: '#1976D2', marginBottom: '0.5rem', fontWeight: '700', letterSpacing: '0.5px' }}>7" PULLS</div>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#1565C0' }}>{calculations.finalPulls7}</div>
            <div style={{ fontSize: '11px', color: '#1976D2', marginTop: '4px' }}>
              Auto: {calculations.pulls7} + Manual: {calculations.manualPulls7}
            </div>
            <div style={{ fontSize: '12px', color: '#1976D2', marginTop: '4px', fontWeight: '600' }}>
              ${calculations.pulls7Cost.toFixed(2)}
            </div>
          </div>
          
          {/* 10" Pulls Card */}
          <div style={{ backgroundColor: '#F3E5F5', padding: '1.25rem', borderRadius: '8px', border: '2px solid #9C27B0' }}>
            <div style={{ fontSize: '11px', color: '#7B1FA2', marginBottom: '0.5rem', fontWeight: '700', letterSpacing: '0.5px' }}>10" PULLS</div>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#6A1B9A' }}>{calculations.finalPulls10}</div>
            <div style={{ fontSize: '11px', color: '#7B1FA2', marginTop: '4px' }}>
              Auto: {calculations.pulls10} + Manual: {calculations.manualPulls10}
            </div>
            <div style={{ fontSize: '12px', color: '#7B1FA2', marginTop: '4px', fontWeight: '600' }}>
              ${calculations.pulls10Cost.toFixed(2)}
            </div>
          </div>
          
          {/* Countertop Sqft Card */}
          <div style={{ backgroundColor: '#FFF3E0', padding: '1.25rem', borderRadius: '8px', border: '2px solid #FF9800' }}>
            <div style={{ fontSize: '11px', color: '#E65100', marginBottom: '0.5rem', fontWeight: '700', letterSpacing: '0.5px' }}>COUNTERTOP SQFT</div>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#E65100' }}>{calculations.sqftTotal.toFixed(2)}</div>
            <div style={{ fontSize: '11px', color: '#E65100', marginTop: '4px' }}>
              Auto-calculated from cabinets
            </div>
          </div>
          
          {/* Vanity Sinks Card */}
          <div style={{ backgroundColor: '#E8F5E9', padding: '1.25rem', borderRadius: '8px', border: '2px solid #4CAF50' }}>
            <div style={{ fontSize: '11px', color: '#2E7D32', marginBottom: '0.5rem', fontWeight: '700', letterSpacing: '0.5px' }}>VANITY SINKS</div>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#2E7D32' }}>{calculations.finalVanitySinks}</div>
            <div style={{ fontSize: '11px', color: '#2E7D32', marginTop: '4px' }}>
              Auto: {calculations.vanitySinks} + Manual: {calculations.manualVanitySinks}
            </div>
            <div style={{ fontSize: '12px', color: '#2E7D32', marginTop: '4px', fontWeight: '600' }}>
              ${calculations.vanitySinkCost.toFixed(2)}
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: '#F9FAFB', borderRadius: '8px', padding: '1.5rem', marginBottom: '1.5rem' }}>
          <CabinetSection title="Base Cabinets" items={cabinetData.base} />
          <CabinetSection title="Wall Cabinets" items={cabinetData.wall} />
          <CabinetSection title="Vanity Cabinets" items={cabinetData.vanity} />
          <CabinetSection title="Cabinet Accessories" items={cabinetData.accessories} />
        </div>

        <div style={{ backgroundColor: '#F9FAFB', borderRadius: '8px', padding: '1.5rem' }}>
          <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#1F2937', marginBottom: '1.5rem' }}>Features & Labor</h2>
          
          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1F2937', marginBottom: '1rem' }}>Hardware & Handles</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
              {['Locking Door Handle Interior', 'Hall/Closet Door Handle Interior', 'Pocket Door Handle', 'Exterior Lock Sets', 'Dummy Knobs'].map(f => (
                <div key={f} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                  border: '1px solid #E5E7EB', borderRadius: '6px', padding: '0.75rem', backgroundColor: 'white' }}>
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1F2937' }}>{f}</div>
                    <div style={{ fontSize: '11px', color: '#6B7280' }}>${featurePrices[f]}</div>
                  </div>
                  <input type="number" min="0" value={features[f] || 0} 
                    onChange={e => setFeatures(p => ({ ...p, [f]: Math.max(0, parseInt(e.target.value) || 0) }))}
                    style={{ width: '60px', padding: '4px 8px', border: '1px solid #D1D5DB', borderRadius: '4px', textAlign: 'center' }} />
                </div>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1F2937', marginBottom: '1rem' }}>
              Cabinet Pulls (Additional Manual Entries)
            </h3>
            <p style={{ fontSize: '12px', color: '#666', marginBottom: '0.75rem', fontStyle: 'italic' }}>
              These values will be ADDED to the auto-calculated quantities
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
              {['5" Cabinet Door Pulls', '7" Cabinet Door Pulls', '10" Cabinet Door Pulls'].map(f => (
                <div key={f} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                  border: '1px solid #E5E7EB', borderRadius: '6px', padding: '0.75rem', backgroundColor: 'white' }}>
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1F2937' }}>{f}</div>
                    <div style={{ fontSize: '11px', color: '#6B7280' }}>${featurePrices[f]}</div>
                    {f === '7" Cabinet Door Pulls' && (
                      <div style={{ fontSize: '10px', color: '#3B82F6', marginTop: '2px' }}>
                        Auto: {calculations.pulls7} → Total: {calculations.finalPulls7}
                      </div>
                    )}
                    {f === '10" Cabinet Door Pulls' && (
                      <div style={{ fontSize: '10px', color: '#3B82F6', marginTop: '2px' }}>
                        Auto: {calculations.pulls10} → Total: {calculations.finalPulls10}
                      </div>
                    )}
                  </div>
                  <input type="number" min="0" value={features[f] || 0} 
                    onChange={e => setFeatures(p => ({ ...p, [f]: Math.max(0, parseInt(e.target.value) || 0) }))}
                    style={{ width: '60px', padding: '4px 8px', border: '1px solid #D1D5DB', borderRadius: '4px', textAlign: 'center' }} />
                </div>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1F2937', marginBottom: '1rem' }}>
              Countertops (Additional Manual SQFT)
            </h3>
            <p style={{ fontSize: '12px', color: '#666', marginBottom: '0.75rem', fontStyle: 'italic' }}>
              Auto-calculated: {calculations.sqftTotal.toFixed(2)} sqft. Manual entries below will be ADDED to this amount.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
              {['Countertop Entry Level', 'Countertop Group A', 'Countertop Group B', 'Countertop OTHER'].map(f => {
                const manualValue = features[f] || 0;
                const totalValue = calculations.sqftTotal + manualValue;
                
                return (
                  <div key={f} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                    border: '1px solid #E5E7EB', borderRadius: '6px', padding: '0.75rem', backgroundColor: 'white' }}>
                    <div>
                      <div style={{ fontSize: '13px', fontWeight: '600', color: '#1F2937' }}>{f}</div>
                      <div style={{ fontSize: '11px', color: '#6B7280' }}>${featurePrices[f]}/sqft</div>
                      {manualValue > 0 && (
                        <div style={{ fontSize: '10px', color: '#3B82F6', marginTop: '2px' }}>
                          Total: {totalValue.toFixed(2)} sqft
                        </div>
                      )}
                    </div>
                    <input type="number" min="0" step="0.1" value={features[f] || 0} 
                      onChange={e => setFeatures(p => ({ ...p, [f]: Math.max(0, parseFloat(e.target.value) || 0) }))}
                      style={{ width: '60px', padding: '4px 8px', border: '1px solid #D1D5DB', borderRadius: '4px', textAlign: 'center' }} />
                  </div>
                );
              })}
            </div>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1F2937', marginBottom: '1rem' }}>Sinks</h3>
            <p style={{ fontSize: '12px', color: '#666', marginBottom: '0.75rem', fontStyle: 'italic' }}>
              Vanity Sink Rectangle is auto-calculated. Manual entry will be ADDED to auto-calculated value.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
              {['Kitchen Sink UM', 'Kitchen Sink Upgrade', 'Kitchen Sink Upgrade (Kraus)', 'Vanity Sink Rectangle', 'Vanity Sink Oval', 'Laundry', 'Bar'].map(f => (
                <div key={f} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                  border: '1px solid #E5E7EB', borderRadius: '6px', padding: '0.75rem', backgroundColor: 'white' }}>
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1F2937' }}>{f}</div>
                    <div style={{ fontSize: '11px', color: '#6B7280' }}>${featurePrices[f]}</div>
                    {f === 'Vanity Sink Rectangle' && (
                      <div style={{ fontSize: '10px', color: '#3B82F6', marginTop: '2px' }}>
                        Auto: {calculations.vanitySinks} → Total: {calculations.finalVanitySinks}
                      </div>
                    )}
                  </div>
                  <input type="number" min="0" value={features[f] || 0} 
                    onChange={e => setFeatures(p => ({ ...p, [f]: Math.max(0, parseInt(e.target.value) || 0) }))}
                    style={{ width: '60px', padding: '4px 8px', border: '1px solid #D1D5DB', borderRadius: '4px', textAlign: 'center' }} />
                </div>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1F2937', marginBottom: '1rem' }}>Other Features</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
              {['Mirrors / Brackets', '4-8\' Bench', '8\' or more Bench'].map(f => (
                <div key={f} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                  border: '1px solid #E5E7EB', borderRadius: '6px', padding: '0.75rem', backgroundColor: 'white' }}>
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1F2937' }}>{f}</div>
                    <div style={{ fontSize: '11px', color: '#6B7280' }}>${featurePrices[f]}</div>
                  </div>
                  <input type="number" min="0" value={features[f] || 0} 
                    onChange={e => setFeatures(p => ({ ...p, [f]: Math.max(0, parseInt(e.target.value) || 0) }))}
                    style={{ width: '60px', padding: '4px 8px', border: '1px solid #D1D5DB', borderRadius: '4px', textAlign: 'center' }} />
                </div>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: '1.5rem', padding: '1rem', backgroundColor: '#EEF2FF', borderRadius: '8px', border: '2px solid #818CF8' }}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '0.5rem' }}>
              Cabinet Labor ($50/unit)
            </label>
            <input 
              type="number" 
              min="0" 
              value={cabinetLaborUnits} 
              onChange={e => setCabinetLaborUnits(parseInt(e.target.value) || 0)}
              style={{ width: '150px', padding: '8px 12px', border: '1px solid #D1D5DB', borderRadius: '6px', backgroundColor: 'white', fontSize: '14px', marginBottom: '1rem' }} 
            />
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '0.5rem' }}>
              Extra Labor ($75/unit)
            </label>
            <input type="number" min="0" value={laborExtra} onChange={e => setLaborExtra(parseInt(e.target.value) || 0)}
              style={{ width: '150px', padding: '8px 12px', border: '1px solid #D1D5DB', borderRadius: '6px', backgroundColor: 'white' }} />
            <div style={{ fontSize: '13px', color: '#4F46E5', marginTop: '0.5rem', fontWeight: '600' }}>
              Total Labor: ${calculations.laborTotal.toFixed(2)}
            </div>
          </div>
          <div>
            <button onClick={() => { setCabinetQuantities({}); setFeatures({}); setLaborCabs(0); setLaborExtra(0); setCabinetLaborUnits(0); }} 
              style={{ padding: '8px 16px', backgroundColor: '#EF4444', color: 'white', border: 'none', borderRadius: '6px', 
                cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>
              Clear All
            </button>
            <button 
              onClick={() => { applyPricingToCabinets(calculations, features, laborCabs, laborExtra); }} 
              disabled={isSaving}
              style={{ padding: '8px 16px', backgroundColor: isSaving ? '#9CA3AF' : 'green', color: 'white', border: 'none', borderRadius: '6px', 
                cursor: isSaving ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '600', marginLeft: '8px' }}>
              {isSaving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}